import { getServerBase } from './server';

/**
 * Adressen zum Weitergeben.
 *
 * `window.location.origin` taugt dafür nur im Browser. In der Android-App ist
 * das `https://localhost` - Capacitors eingebauter Server. Ein so gebauter
 * Link führt beim Empfänger ins Leere. Deshalb hat die eingerichtete
 * Serveradresse Vorrang, sobald es eine gibt.
 */

export function appBaseUrl(): string {
  return getServerBase() || window.location.origin;
}

/** Link, mit dem ein Mitfahrer direkt in die Fahrt einsteigt. */
export function joinLink(code: string): string {
  return `${appBaseUrl()}/?code=${encodeURIComponent(code)}`;
}

/** Link, mit dem sich ein Freund einmalig als Kontakt verbindet. */
export function connectLink(code: string): string {
  return `${appBaseUrl()}/?connect=${encodeURIComponent(code)}`;
}

/**
 * Teilen über das System-Menü, mit Zwischenablage als Rückfallebene.
 * Gibt zurück, was der Oberfläche zu melden ist - oder null, wenn der
 * Nutzer den Dialog einfach abgebrochen hat.
 */
export async function shareText(options: {
  title: string;
  text: string;
  url: string;
}): Promise<string | null> {
  if (navigator.share) {
    try {
      await navigator.share(options);
      return null;
    } catch {
      return null; // Abgebrochen - kein Grund für eine Meldung.
    }
  }
  try {
    await navigator.clipboard.writeText(`${options.text}\n${options.url}`);
    return 'Link kopiert.';
  } catch {
    return 'Teilen ist hier nicht möglich - bitte den Link von Hand kopieren.';
  }
}
